export const BridgeMark = ({ className = "h-9 w-auto", light = false }) => (
  <img src={light ? "/logo-mark-white.png" : "/logo-mark.png"} alt="" aria-hidden="true" className={className} width="400" height="269" />
);

export const Logo = ({ light = false, lang = "en", testId = "logo", label }) => (
  <span data-testid={testId} title={label} className="inline-flex items-center gap-3" aria-label="Atlas Bridge Logistics">
    <BridgeMark light={light} className="h-10 w-auto" />
    <span className="leading-none">
      <span className={`block font-serif text-[1.15rem] font-semibold tracking-tight ${light ? "text-white" : "text-[#1E3A5F]"}`}>
        {lang === "ar" ? "أطلس بريدج" : "Atlas Bridge"}
      </span>
      <span className={`mt-1 block text-[0.62rem] font-semibold uppercase tracking-[0.32em] ${light ? "text-[#C9D4E1]" : "text-[#4A5D75]"}`}>
        {lang === "ar" ? "للخدمات اللوجستية" : "Logistics"}
      </span>
    </span>
  </span>
);
